export default __webpack_public_path__ + "static/media/C0005.29b05ab8.png";